import DoublyLinkedList from './DoublyLinkedList';

export default DoublyLinkedList;
